export default __webpack_public_path__ + "static/media/property_846.71ec3812.png";